var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-sidenav" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-lg-start align-items-center close-icon"
      },
      [
        _c(
          "div",
          {
            staticClass: "d-flex close-menu pointer",
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "30",
                  height: "30",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
                    fill: "white"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "pl-2 close-menu-text" }, [
              _vm._v("\n        Close\n      ")
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex flex-column justify-content-center mt-4" },
      [
        _vm.permissions && !_vm.user.company_setup_step
          ? _c(
              "div",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "menu-item-link",
                    attrs: { to: "/", exact: "" },
                    nativeOn: {
                      click: function($event) {
                        _vm.$emit("clickLink")
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "menu-item" }, [
                      _c("div", { staticClass: "mod-icon mod-icon-dashboard" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-item-name pl-4" }, [
                        _vm._v("\n            Dashboard\n          ")
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "menu-item-link",
                    attrs: { to: "/schedule", exact: "" },
                    nativeOn: {
                      click: function($event) {
                        _vm.$emit("clickLink")
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "menu-item" }, [
                      _c("div", {
                        staticClass: "mod-icon mod-icon-schedule",
                        staticStyle: {
                          width: "28px",
                          height: "28px",
                          "margin-left": "2px"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-item-name pl-4" }, [
                        _vm._v("\n            Schedule\n          ")
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.$_can("leads.index") || _vm.$_can("leads.index-own")
                  ? _c(
                      "router-link",
                      {
                        staticClass: "menu-item-link",
                        attrs: { to: "/leads", exact: "" },
                        nativeOn: {
                          click: function($event) {
                            _vm.$emit("clickLink")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "menu-item" }, [
                          _c("div", { staticClass: "mod-icon mod-icon-leads" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-item-name pl-4" }, [
                            _vm._v("\n            Leads\n          ")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$_can("jobs.index") || _vm.$_can("jobs.index-own")
                  ? _c(
                      "router-link",
                      {
                        staticClass: "menu-item-link",
                        attrs: { to: "/jobs", exact: "" },
                        nativeOn: {
                          click: function($event) {
                            _vm.$emit("clickLink")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "menu-item" }, [
                          _c("div", { staticClass: "mod-icon mod-icon-jobs" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-item-name pl-4" }, [
                            _vm._v("\n            Jobs\n          ")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$_can("claims.index") || _vm.$_can("claims.index-own")
                  ? _c(
                      "router-link",
                      {
                        staticClass: "menu-item-link",
                        attrs: { to: "/claims", exact: "" },
                        nativeOn: {
                          click: function($event) {
                            _vm.$emit("clickLink")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "menu-item" }, [
                          _c("div", {
                            staticClass: "mod-icon mod-icon-claims"
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-item-name pl-4" }, [
                            _vm._v("\n            Claims\n          ")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { attrs: { id: "organizations" } }, [
                  _vm.$_can("carriers.index") ||
                  _vm.$_can("companies.index") ||
                  _vm.$_can("clusters.users.index") ||
                  _vm.$_can("companies.customers.index") ||
                  _vm.$_can("carriers.movers.index") ||
                  _vm.$_can("carriers.trucks.index")
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "menu-item-link d-flex flex-column align-items-start",
                          class: [
                            _vm.isOrganizationsActive ||
                            _vm.expanded.includes("organizations")
                              ? "router-link-active"
                              : ""
                          ],
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#organization",
                            "aria-expanded": "true",
                            to: "#"
                          },
                          on: {
                            click: function($event) {
                              _vm.toggle("organizations")
                            }
                          }
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("hr", { staticClass: "link-divider" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse mt-3 w-100",
                              class: [_vm.isOrganizationsActive ? "show" : ""],
                              attrs: {
                                id: "organization",
                                "aria-labelledby": "organization",
                                "data-parent": "#organizations"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "submenu-wrapper" },
                                [
                                  _vm.$_can("companies.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/companies" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Companies")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$_can("carriers.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/carriers" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Carriers")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$_can("clusters.users.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/users" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Users")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$_can("companies.customers.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/customers" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Customers")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$_can("carriers.movers.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/movers" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Movers")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$_can("carriers.trucks.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/trucks" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Trucks")]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("span", { attrs: { id: "payments" } }, [
                  _vm.$_can("job-charges.index") || _vm.canAccessPayments
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "menu-item-link d-flex flex-column align-items-start",
                          class: [
                            _vm.isPaymentsActive ||
                            _vm.expanded.includes("payment")
                              ? "router-link-active"
                              : ""
                          ],
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#payment",
                            "aria-expanded": "true",
                            to: "#"
                          },
                          on: {
                            click: function($event) {
                              _vm.toggle("payment")
                            }
                          }
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("hr", { staticClass: "link-divider" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse mt-3 w-100",
                              class: [_vm.isPaymentsActive ? "show" : ""],
                              attrs: {
                                id: "payment",
                                "aria-labelledby": "organization",
                                "data-parent": "#payments"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "submenu-wrapper" },
                                [
                                  _vm.$_can("job-charges.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/transactions" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Transactions")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canAccessPayments
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: {
                                            to: "/settings/payment-gateways"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Payment Gateways")]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("span", { attrs: { id: "preferences" } }, [
                  _vm.$_can("leads.follow-up-email-templates.index") ||
                  _vm.$_can("phone-numbers.index") ||
                  _vm.$_can("leads.follow-ups.index") ||
                  _vm.$_can("carriers.roles.index") ||
                  _vm.$_can("companies.domains.index") ||
                  _vm.$_can("companies.configurations.index")
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "menu-item-link d-flex flex-column align-items-start",
                          class: [
                            _vm.isSettingsActive || _vm.isSettingsOpen
                              ? "router-link-active"
                              : ""
                          ],
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#settings",
                            "aria-expanded": "true",
                            to: "#"
                          },
                          on: {
                            click: function($event) {
                              _vm.toggle("settings-top-level")
                            }
                          }
                        },
                        [
                          _vm._m(2),
                          _vm._v(" "),
                          _c("hr", { staticClass: "link-divider" })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse  w-100",
                      class: [_vm.isSettingsActive ? "show" : ""],
                      attrs: {
                        id: "settings",
                        "aria-labelledby": "organization",
                        "data-parent": "#preferences"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "submenu-wrapper",
                          class: [
                            _vm.isSettingsActive || _vm.isSettingsOpen
                              ? "router-link-active"
                              : ""
                          ]
                        },
                        [
                          _c("span", { attrs: { id: "domains" } }, [
                            _vm.$_can("companies.domains.index")
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "menu-item-link submenu-item-tier3 d-flex flex-column align-items-start",
                                    attrs: {
                                      "data-toggle": "collapse",
                                      "data-target": "#mailing",
                                      "aria-expanded": "true",
                                      to: "#"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.toggle("mailing")
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "l-sidebar-menu-title" },
                                      [_vm._v("Mailing")]
                                    ),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-caret-down submenu-caret"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "collapse mt-3 w-100",
                                        attrs: {
                                          id: "mailing",
                                          "aria-labelledby": "mailing",
                                          "data-parent": "#domains"
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "menu-item-link submenu-item d-flex flex-column align-items-start",
                                            attrs: {
                                              to: "/settings/smtp-servers"
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                _vm.$emit("clickLink")
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "l-sidebar-menu-title"
                                              },
                                              [_vm._v("SMTP servers")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.$_can(
                                          "leads.follow-up-email-templates.index"
                                        )
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "menu-item-link submenu-item d-flex flex-column align-items-start",
                                                attrs: {
                                                  to:
                                                    "/settings/follow-up-templates"
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    _vm.$emit("clickLink")
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "l-sidebar-menu-title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Follow up templates"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.$_can(
                                          "claims.email-templates.index"
                                        )
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "menu-item-link submenu-item d-flex flex-column align-items-start",
                                                attrs: {
                                                  to:
                                                    "/settings/claim-templates"
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    _vm.$emit("clickLink")
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "l-sidebar-menu-title"
                                                  },
                                                  [_vm._v("Claim emails")]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.$_can(
                                          "claims.acknowledgement-email-templates.index"
                                        )
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "menu-item-link submenu-item d-flex flex-column align-items-start",
                                                attrs: {
                                                  to:
                                                    "/settings/acknowledgement-templates"
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    _vm.$emit("clickLink")
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "l-sidebar-menu-title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Acknowledgement emails"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.$_can(
                                          "claims.settlement-email-templates.index"
                                        )
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "menu-item-link submenu-item d-flex flex-column align-items-start",
                                                attrs: {
                                                  to:
                                                    "/settings/settlement-templates"
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    _vm.$emit("clickLink")
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "l-sidebar-menu-title"
                                                  },
                                                  [_vm._v("Settlement emails")]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.$_can("carriers.roles.index")
                            ? _c(
                                "router-link",
                                {
                                  staticClass:
                                    "menu-item-link submenu-item-tier3 d-flex flex-column align-items-start",
                                  attrs: { to: "/settings/user-roles" },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.$emit("clickLink")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "l-sidebar-menu-title" },
                                    [_vm._v("User roles")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$_can("phone-numbers.index")
                            ? _c(
                                "router-link",
                                {
                                  staticClass:
                                    "menu-item-link submenu-item-tier3 d-flex flex-column align-items-start",
                                  attrs: { to: "/settings/phone-numbers" },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.$emit("clickLink")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "l-sidebar-menu-title" },
                                    [_vm._v("Phone numbers")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { attrs: { id: "messages" } }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "menu-item-link submenu-item-tier3 d-flex flex-column align-items-start",
                                attrs: {
                                  "data-toggle": "collapse",
                                  "data-target": "#message",
                                  "aria-expanded": "true",
                                  to: "#"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.toggle("messages")
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "l-sidebar-menu-title" },
                                  [_vm._v("Messages")]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa fa-caret-down submenu-caret"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapse mt-3 w-100",
                                    attrs: {
                                      id: "message",
                                      "aria-labelledby": "messages",
                                      "data-parent": "#messages"
                                    }
                                  },
                                  [
                                    _vm.$_can("settings.messages.index-all") ||
                                    _vm.$_can("settings.messages.index-own")
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "menu-item-link submenu-item d-flex flex-column align-items-start",
                                            attrs: { to: "/settings/messages" },
                                            nativeOn: {
                                              click: function($event) {
                                                _vm.$emit("clickLink")
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "l-sidebar-menu-title"
                                              },
                                              [_vm._v("Customer Messages")]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$_can(
                                      "carriers.movers.get-text-message-threads"
                                    )
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "menu-item-link submenu-item d-flex flex-column align-items-start",
                                            attrs: {
                                              to: "/settings/mover-messages"
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                _vm.$emit("clickLink")
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "l-sidebar-menu-title"
                                              },
                                              [_vm._v("Mover Messages")]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.$_can("companies.configurations.index")
                            ? _c(
                                "router-link",
                                {
                                  staticClass:
                                    "menu-item-link submenu-item-tier3 d-flex flex-column align-items-start",
                                  attrs: { to: "/rates" },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.$emit("clickLink")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "l-sidebar-menu-title" },
                                    [_vm._v("Rates")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$_can("claims.types.index")
                            ? _c(
                                "router-link",
                                {
                                  staticClass:
                                    "menu-item-link submenu-item-tier3 d-flex flex-column align-items-start",
                                  attrs: { to: "/settings/claim-types" },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.$emit("clickLink")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "l-sidebar-menu-title" },
                                    [_vm._v("Claim types")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "menu-item-link submenu-item-tier3 d-flex flex-column align-items-start",
                              attrs: { to: "/contracts" },
                              nativeOn: {
                                click: function($event) {
                                  _vm.$emit("clickLink")
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "l-sidebar-menu-title" },
                                [_vm._v("Contracts")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "menu-item-link submenu-item-tier3 d-flex flex-column align-items-start",
                              attrs: { to: "/settings/filters" },
                              nativeOn: {
                                click: function($event) {
                                  _vm.$emit("clickLink")
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "l-sidebar-menu-title" },
                                [_vm._v("Filters")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.$_can("tags.show")
                            ? _c(
                                "router-link",
                                {
                                  staticClass:
                                    "menu-item-link submenu-item-tier3 d-flex flex-column align-items-start",
                                  attrs: { to: "/settings/tags" },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.$emit("clickLink")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "l-sidebar-menu-title" },
                                    [_vm._v("Tags")]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", { attrs: { id: "statistics" } }, [
                  _vm.$_can("clusters.totals.index")
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "menu-item-link d-flex flex-column align-items-start",
                          class: [
                            _vm.isStatisticsActive ||
                            _vm.expanded.includes("statistics")
                              ? "router-link-active"
                              : ""
                          ],
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#statistic",
                            "aria-expanded": "true",
                            to: "#"
                          },
                          on: {
                            click: function($event) {
                              _vm.toggle("statistics")
                            }
                          }
                        },
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _c("hr", { staticClass: "link-divider" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse mt-3 w-100",
                              class: [_vm.isStatisticsActive ? "show" : ""],
                              attrs: {
                                id: "statistic",
                                "aria-labelledby": "statistic",
                                "data-parent": "#statistics"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "submenu-wrapper" },
                                [
                                  _vm.$_can("clusters.totals.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/reports/totals" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Totals")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$_can("movers.wages.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: {
                                            to: "/reports/mover-totals"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Mover Totals")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$_can("sales.view-totals")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/reports/sales" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Sales Totals")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$_can("job-discounts.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/reports/discounts" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Discounts")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$_can("companies.payment-profiles.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "menu-item-link submenu-item d-flex flex-column align-items-start",
                                          attrs: { to: "/reports/ratings" },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.$emit("clickLink")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Ratings")]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-lg-start align-items-center logout-wrapper logout-icon"
          },
          [
            _c(
              "div",
              {
                staticClass: "d-flex close-menu pointer",
                on: {
                  click: function($event) {
                    _vm.$emit("logout")
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "28",
                      height: "28",
                      viewBox: "0 0 24 22",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M0 4.24702V17.0207C0 18.1968 0.490041 19.2423 1.27411 20.059C2.05817 20.8431 3.07092 21.2678 4.24702 21.2678H10.6502V18.6215H4.24702C3.36494 18.6215 2.67889 17.9028 2.67889 17.0207V4.24702C2.67889 3.36495 3.36494 2.67889 4.24702 2.67889H10.6502V0H4.24702C3.07092 0 2.05817 0.457371 1.27411 1.24144C0.490041 2.05817 0 3.07092 0 4.24702ZM7.02391 8.102V13.1984C7.02391 13.7865 7.54662 14.2765 8.13467 14.2765H14.0478V18.2948C14.0478 18.6542 14.2438 18.9482 14.5705 19.1116C14.7012 19.1443 14.8319 19.1443 14.8972 19.1443C15.1259 19.1443 15.3219 19.0789 15.4853 18.9156L23.1626 11.2383C23.5219 10.9442 23.4893 10.3562 23.1626 10.0295L15.4853 2.38486C15.0279 1.89482 14.0478 2.18885 14.0478 2.97291V7.02392H8.13467C7.54662 7.02392 7.02391 7.51396 7.02391 8.102Z",
                        fill: "white"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "pl-4 close-menu-text" }, [
                  _vm._v("\n          Logout\n        ")
                ])
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-item" }, [
      _c("div", { staticClass: "mod-icon mod-icon-main-users" }),
      _vm._v(" "),
      _c("span", { staticClass: "menu-item-name pl-4" }, [
        _vm._v("\n              Organization\n            ")
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-caret-down menu-caret" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-item" }, [
      _c("div", { staticClass: "mod-icon mod-icon-payments" }),
      _vm._v(" "),
      _c("span", { staticClass: "menu-item-name pl-4" }, [
        _vm._v("\n              Payment\n            ")
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-caret-down menu-caret" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-item" }, [
      _c("div", { staticClass: "mod-icon mod-icon-settings" }),
      _vm._v(" "),
      _c("span", { staticClass: "menu-item-name pl-4" }, [
        _vm._v("\n              Preferences\n            ")
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-caret-down menu-caret" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-item" }, [
      _c("div", { staticClass: "mod-icon mod-icon-reports" }),
      _vm._v(" "),
      _c("span", { staticClass: "menu-item-name pl-4" }, [
        _vm._v("\n              Statistics\n            ")
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-caret-down menu-caret" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "a",
        {
          staticClass: "menu-item-link",
          attrs: { href: "https://docs.mod24.com/mod24/", target: "_blank" }
        },
        [
          _c("div", { staticClass: "menu-item" }, [
            _c("div", { staticClass: "mod-icon mod-icon-help" }),
            _vm._v(" "),
            _c("span", { staticClass: "menu-item-name pl-4" }, [
              _vm._v("\n            Help\n          ")
            ])
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d9d40b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d9d40b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MobileSidenav.vue
// module id = null
// module chunks = 